import {ProductInterface} from "../../interfaces/product/ProductInterface";

export default function BundleIncludes({product}: { product: ProductInterface }) {
    return (<div className="flex-column flex-lg-row gap-4  justify-content-between prod-pane ">
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">Комплектация</p>
                {product.additional_params.specification_list_raw?.map(item => <p>{item}</p>)}
            </div>
        </div>

    </div>)
}